const getUnreadMessagesCount = (state) => state.unreadMessagesCount;

const getMessagesByUser = (state) => state.messagesByUser;

export default {
  getUnreadMessagesCount,
  getMessagesByUser,
};
